import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52fff2a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "status" }
const _hoisted_3 = { class: "float-end" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Inloggad användare", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "float-end" }, null, -1))
const _hoisted_6 = { class: "status-table" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "ID:", -1))
const _hoisted_8 = { class: "avatar" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Namn:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "E-post:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Roller:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_14 = { class: "role-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_messages = _resolveComponent("messages")!
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_messages, { ref: "errorHandler" }, null, 512)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          class: "btn btn-lg btn-outline-secondary mt-1",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args)))
        }, [
          _createVNode(_component_fa_icon, { icon: "sync-alt" })
        ])
      ]),
      _hoisted_4,
      _createVNode(_component_fa_icon, {
        hidden: !_ctx.loadingUser,
        icon: "spinner",
        spin: _ctx.loadingUser,
        size: "3x"
      }, null, 8, ["hidden", "spin"]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", null, _toDisplayString((_ctx.user && _ctx.user.uuid) || '-'), 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            src: _ctx.profilePhoto,
            alt: "[User Avatar]",
            class: "border border-secondary rounded-circle profile-avatar"
          }, null, 8, _hoisted_9)
        ]),
        _hoisted_10,
        _createElementVNode("div", null, _toDisplayString((_ctx.user && _ctx.user.fullName) || '-'), 1),
        _hoisted_11,
        _createElementVNode("div", null, _toDisplayString((_ctx.user && _ctx.user.email) || '-'), 1),
        _hoisted_12,
        _hoisted_13,
        (_ctx.user && _ctx.user.appRoles)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.user.appRoles, (role) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: role.uuid
              }, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(role.name), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(role.permissions, (perm) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: perm,
                    class: "permissions"
                  }, _toDisplayString(perm), 1))
                }), 128))
              ], 64))
            }), 128))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}